import {Optional, Project} from 'data/types'
import published from 'utils/published'
import selector from 'utils/selector'
import APIService from './APIService'

class ProjectService {
  private projectId: number

  public project = published<Optional<Project>>(null)

  public constructor(projectId: string) {
    this.projectId = parseInt(projectId, 10)
    this.load()
  }

  private load = async () => {
    this.project.startLoading()
    const result = await APIService.getProject(this.projectId)
    if (result.ok) {
      this.project.publish(result.body)
    }
    this.project.endLoading()
  }
}

type SelectorProps = {
  token: string
  projectId: string
}

export const projectServiceSelector = selector(
  (props: SelectorProps) => props.projectId,
  (props: SelectorProps) => props.token,
  (projectId) => new ProjectService(projectId)
)
